import React, { useState, useEffect } from 'react';
import snakeCaseKeys from 'snakecase-keys';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { sendAlert } from '../../actions/utils';
import { showCompanyAnnouncementRequest, updateCompanyAnnouncementRequest } from '../../requests/companyAnnouncements';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import defaultCompanyAnnouncement from './companyAnnouncement';
import CompanyAnnouncementForm from './CompanyAnnouncementForm';

const CompanyAnnouncementEdit = ({ moreData, setMoreData }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [announcement, setAnnouncement] = useState(defaultCompanyAnnouncement);
  const [onRequest, setOnRequest] = useState(true);

  const handleUpdateRequest = (announcementValues, setSubmitting) => {
    const { image, attachedFile } = announcementValues.announcement;
    const myParams = snakeCaseKeys(announcementValues);
    myParams.announcement.image = image;
    myParams.announcement.attached_file = attachedFile;

    updateCompanyAnnouncementRequest(id, {
      dispatch,
      params: myParams,
      formData: true,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Anuncio actualizado con éxito' }));
        history.push('/company_announcements');
      },
      failureCallback: error => {
        setSubmitting(false);
        const { response } = error;
        dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
      },
      callback: () => setMoreData?.(!moreData)
    });
  };

  const handleShowRequest = () => {
    setOnRequest(true);
    showCompanyAnnouncementRequest(id, {
      dispatch,
      successCallback: res => {
        setAnnouncement(camelCaseEmptyStringRecursive(res.data));
        setOnRequest(false);
      }
    });
  };

  useEffect(handleShowRequest, []);

  return (
    <>
      {onRequest && <Spinner className="spinner-modal fix-spinner" animation="border" variant="primary" />}
      <div className={`${onRequest && 'bg-opacity'}`}>
        <CompanyAnnouncementForm announcement={announcement} action="edit" formRequest={handleUpdateRequest} />
      </div>
    </>
  );
};

export default CompanyAnnouncementEdit;
